import React from 'react';
import { useSelector } from 'react-redux';
// import Comment from './Comment/Comment';
import unknownUser from './../../../../../assets/img/unknown150.jpg';
import s from './Post.module.css';

const  Post = ({postText, likesCount, userPhoto}) => {
    const {fullName} = useSelector(({profile}) => profile.profilePage)

    return (
        <div className={s.post}>
            <div className={s.post__info}>
                <div className={s.post__photo}>
                    <img src={userPhoto ? userPhoto : unknownUser} alt="user photo"/>
                </div>
                <div className={s.post__detail}>
                    <div className={s.user__name}>{fullName}</div>
                    <div className={s.post__time}>7 hour ago</div>
                </div>
            </div>
            <div className={s.post__text}>{postText}</div>
            <div className={s.post__counter}>
            <span className={s.post__counterItem}>Likes: {likesCount}</span>
                <span className={s.post__counterItem}>Comments</span>
                <span className={s.post__counterItem}>Share</span>
            </div>
            <div className={s.post__comments}>
                {/* <Comment/> */}
            </div>
        </div>
    )
}

export default Post
